import React from 'react';

import useAppointmentCancelledNotification, { NotificationProps, NotificationComponents } from './useAppointmentCancelledNotification';
import AppointmentCancelledNotificationClient from './AppointmentCancelledNotificationClient';
import NcdAppointmentCancelledNotificationClient from './NcdAppointmentCancelledNotificationClient';
import NcdFeeRefundedAppointmentCancelledNotificationClient from './NcdFeeRefundedAppointmentCancelledNotificationClient';
import NcdAppointmentCancelledNotificationProvider from './NcdAppointmentCancelledNotificationProvider';
import NcdAppointmentCancelledNotificationProviderNoShow from './NcdAppointmentCancelledNotificationProviderNoShow';

type AppointmentCancelledNotificationContainerProps = {
  notification: NotificationProps;
};

const AppointmentCancelledNotificationContainer:
React.FC<AppointmentCancelledNotificationContainerProps> = ({
  notification,
}) => {
  const {
    notificationComponent,
    handleCTAClick,
    handleNotificationClick,
    clientName,
    serviceName,
    startTime,
  } = useAppointmentCancelledNotification(notification);

  return (
    <React.Fragment>
      {(notificationComponent === NotificationComponents.Client) && (
        <AppointmentCancelledNotificationClient
          notification={notification}
          onNotificationClick={handleNotificationClick}
          clientName={clientName}
          serviceName={serviceName}
          startTime={startTime}
        />
      )}
      {notificationComponent === NotificationComponents.NcdClient && (
        <NcdAppointmentCancelledNotificationClient
          notification={notification}
          onCTAClick={handleCTAClick}
          clientName={clientName}
          serviceName={serviceName}
          startTime={startTime}
        />
      )}
      {notificationComponent === NotificationComponents.NcdFeeRefundedClient && (
        <NcdFeeRefundedAppointmentCancelledNotificationClient
          notification={notification}
          clientName={clientName}
          serviceName={serviceName}
          startTime={startTime}
        />
      )}
      {notificationComponent === NotificationComponents.NcdProvider && (
        <NcdAppointmentCancelledNotificationProvider
          notification={notification}
          onCTAClick={handleCTAClick}
          clientName={clientName}
        />
      )}
      {notificationComponent === NotificationComponents.NcdNoShow && (
        <NcdAppointmentCancelledNotificationProviderNoShow
          notification={notification}
          onCTAClick={handleCTAClick}
          clientName={clientName}
        />
      )}
    </React.Fragment>
  );
};

export default AppointmentCancelledNotificationContainer;
